/**
 * URL de la page agence (frontend-agency).
 * En dev : localhost:5174/agence/:id
 * En prod sous-domaine : https://subdomain.ziyara.site
 * En prod domaine personnalisé : https://mondomaine.com (subdomain contient l'URL complète)
 */
export function getAgencyPageUrl(agency: {
  id: number | string;
  subdomain?: string;
  domainType?: string;
}): string {
  if (typeof window === 'undefined') {
    return '#';
  }
  const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');

  if (isLocalhost) {
    const base = import.meta.env.VITE_AGENCY_APP_URL || 'http://localhost:5174';
    return `${base.replace(/\/$/, '')}/agence/${agency.id}`;
  }

  const subdomain = (agency.subdomain || '').trim();
  const isCustomDomain = agency.domainType === 'CUSTOM';

  if (isCustomDomain && subdomain) {
    const host = subdomain.replace(/^https?:\/\//i, '').replace(/\/.*$/, '');
    return host ? `https://${host}` : '#';
  }

  const domain = import.meta.env.VITE_APP_DOMAIN || 'ziyara.site';
  return subdomain ? `https://${subdomain}.${domain}` : '#';
}
